import React from 'react';
import { Phone } from 'lucide-react';
import deliveryImage from '../assets/pickup-delivery.jpg';

export default function Pickup() {
  return (
    <section id="pickup" className="py-20 bg-white overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="bg-brand rounded-3xl overflow-hidden shadow-2xl">
          <div className="flex flex-col md:flex-row">
            
            {/* Content */}
            <div className="w-full md:w-1/2 p-8 md:p-12 lg:p-16 flex flex-col justify-center text-white">
              <h2 className="text-3xl md:text-4xl font-bold mb-6">
                Pickup & Delivery Service
              </h2>
              <p
                className="text-white/90 text-lg mb-8 leading-relaxed"
                style={{
                  color: "#ffffff"
                }}>
                We proudly offer scheduled pickup and delivery throughout Sonoma County and Marin County, so you can plan your service at the time that works best for you.
              </p>
              <div className="flex flex-col items-start gap-3">
                <a 
                  href="tel:+17075402900" 
                  className="inline-flex items-center gap-2 bg-white text-brand-dark px-8 py-4 rounded-full font-bold hover:bg-gray-50 transition-colors shadow-lg"
                >
                  <Phone size={18} className="text-brand" />
                  Schedule by Phone – (707) 540-2900
                </a>
                <p className="text-white/80 text-sm ml-2">
                  Call us to arrange your pickup and delivery schedule.
                </p>
              </div>
            </div>

            {/* Image */}
            <div className="w-full md:w-1/2 h-64 md:h-auto relative">
              <img 
                src={deliveryImage} 
                alt="Delivery Van" 
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-brand/20 mix-blend-multiply"></div>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  );
}
